@if (farm?.farmMetadata?.eras) {
  (<span class="color-primary-blue">Número do ERAS {{ farm?.farmMetadata?.eras || '?' }}</span>)
}
@if (farm?.farmMetadata?.sif) {
  (<span class="color-primary-blue">Número do SIF {{ farm?.farmMetadata?.sif || '?' }}</span>)
}
